<template>
    <div class="co-tabela-escolher-modelo">
        <v-data-table
            v-model="modeloSelecionado"
            class="tabela-modelos-escolher-modelo mx-7 my-5"
            hide-default-footer
            show-select
            single-select
            :items="modelosLista"
            :items-per-page="ehMobile ? 5 : paginacao.rowsPerPage"
            :headers="headersModelos"
            checkbox-color="primary"
            no-data-text="Nenhum modelo encontrado."
        >
            <template v-slot:item.acoes="{ item }">
                <div>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon :disabled="carregando" size="20" v-on="on" @click="visualizarModelo(item)"> mdi-eye-outline </v-icon>
                        </template>
                        <span>Visualizar</span>
                    </v-tooltip>
                </div>
            </template>

        </v-data-table>

        <v-flex class="footer-tabela-modelos">
            <v-pagination
                dense
                class="paginas justify-center elevation-0"
                v-model="paginacao.page"
                :length="paginacao.numPages"
                :total-visible="7"
                @input="buscarPagina"
            />
        </v-flex>

        <dialog-visualizar-pdf
            :dialog="dialogVisualizarPdf"
            :pdf="pdfVisualizando"
            @fechar="fecharDialogVisualizarPdf"
        />
    </div>
</template>

<script>
import DialogVisualizarPdf
    from '@/views/criar-documento/novo-documento/components/documento/campos-upload/listaUpload/dialog/DialogVisualizarPdf'
import actionTypes from '@/commons/constants/action-types'


export default {
    name: 'TabelaEscolherModelo',
    components: {
        DialogVisualizarPdf
    },
    props: {
        modelosLista: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        ehSelecionandoModelo: {
            type: Boolean,
            required: true
        }
    },
    watch: {
        modeloSelecionado(value) {
            this.$emit('modelo-selecionado', value)
        },
        ehSelecionandoModelo() {
            this.modeloSelecionado = []
        }
    },
    data() {
        return {
            modeloSelecionado: [],
            carregando: false,
            dialogVisualizarPdf: false,
            pdfVisualizando: {name: '', base64: ''},
            headersModelos: [
                {
                    text: 'Título',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'titulo',
                    width: '90%'
                },
                {
                    text: 'Ações',
                    align: 'center',
                    sortable: false,
                    filterable: true,
                    value: 'acoes'
                }
            ],
        }
    },
    computed: {
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        },
    },
    methods: {
        buscarPagina() {
            this.$emit('buscar-pagina')
        },
        fecharDialogVisualizarPdf() {
            this.pdfVisualizando = {name: '', base64: ''}
            this.dialogVisualizarPdf = false
        },
        async visualizarModelo(modelo) {
            try {
                this.carregando = true
                const modeloBase64 = await this.$store.dispatch(actionTypes.MODELO.BUSCAR_BASE64, {id: modelo.id})

                this.pdfVisualizando = {name: modelo.titulo, base64: 'data:application/pdf;base64,' + modeloBase64.modelo}
                this.dialogVisualizarPdf = true
            } catch {
                this.mostrarNotificacaoErro('Ocorreu um erro ao buscar pelo modelo!')
            } finally {
                this.carregando = false
            }

        }
    }
}
</script>

<style lang="stylus">
.tabela-modelos-escolher-modelo
    .v-data-table-header
        th
            background-color var(--divider-100) !important

</style>
